import React from 'react';
import { isNotEmpty } from '../../lib/ep';
import ActionLink from '../builder/ActionLink';

const PhotoEmbed = (props) => {
	const img = props?.file ?? false;
	if(!img) return null;

	const type_media = props?.type_media ?? 'image';
	const type = props?.type ?? 'gallery';

	let img_set = [];
	let objectFit = 'cover';
	if(!isNotEmpty(img,'base64_code')) {
		let name_file = img?.filename ?? (img?.name ?? null); //From edit
		switch(type_media) {
			case 'youtube':
				name_file = name_file ?? (img?.youtube_id ?? null);//From edit
				img_set.push({ url:`https://i.ytimg.com/vi/${name_file}`, media_query:'all', type:'image/jpeg' });
				break;

			case 'video':
			case 'vimeo':
				if(isNotEmpty(img, 'video_thumb')) name_file = img.video_thumb;
				if(isNotEmpty(img, 'full_path')) {
					img_set.push({ url:`${img.full_path}${name_file}`, media_query:'all', type:'image/jpeg' });
				} else {
					img_set.push({ url:`${window.cdn_url}img/video_processing_thumb.jpg`, media_query:'all', type:'image/jpeg' });
				}
				break;

			case 'pdf':
			case 'image':
			default:
				switch(type) {
					case 'normal':
						img_set.push({ url:`${img.full_path}normal/${name_file}`, media_query:'all', type:'image/jpeg' });
						break;
					case 'big':
						img_set.push({ url:`${img.full_path}normal/${name_file}`, media_query:'(max-width:400px)', type:'image/jpeg' });
						img_set.push({ url:`${img.full_path}big1x/${name_file}`, media_query:'(max-width:1500px)', type:'image/jpeg' });
						img_set.push({ url:`${img.full_path}big2x/${name_file}`, media_query:'(max-width:3000px)', type:'image/jpeg' });
						objectFit = 'contain';
						break;

					case 'thumb':
					case 'gallery':
					default:
						img_set.push({ url:`${img.full_path}${props.type}1x/${name_file}`, media_query:'1x', type:'image/jpeg' });
						img_set.push({ url:`${img.full_path}${props.type}2x/${name_file}`, media_query:'2x', type:'image/jpeg' });
						break;
				}
		}
	} else {
		img_set.push({ url:`${img.base64_code}`, media_query:'all', type:'image/jpeg' });
	}

	let img_props = {
		alt:(img.caption != undefined) ? img.caption : "",
		/*loading:'lazy', --> només s'hauria de posar a les imatges que quedin fora del viewport al carregar la pàgina*/
		src:img_set[0].url,
		style:{
			objectFit,
			objectPosition:(img.offset != undefined) ? `${img.offset?.left ?? 0}% ${img.offset?.top ?? 0}%` : null,
		},
	}

	const adapt = (props.adapt != undefined) ? props.adapt : 'full';
	switch(adapt) {
		case 'height':
			img_props.height = '100%';
			break;

		case 'width':
			img_props.width = '100%';
			break;

		case 'full':
		default:
			img_props.height = '100%';
			img_props.width = '100%';
			break;
	}

	return (
		<div class="photo_embed">
			<picture>
				{img_set.length > 1 && img_set.map((is, i) => {
					return (
						<source key={`${img.filename}_set_${i}`} srcSet={is.url} media={is.media_query} type={is.type} />
					)
				})}

				<img {...img_props} />
			</picture>

			{(isNotEmpty(props, 'full_link')) && (
				<ActionLink
					_href={props.full_link}
					_target='_blank'
					_class={{ other:'full_link' }}
				/>
			)}
		</div>
	)
};

export default PhotoEmbed;